import * as React from 'react';
import { forwardRef } from 'react';

import classnames from 'classnames';

import useAnchorStyles from './AnchorJSS';
import { AnchorModel } from './types';

function Anchor({ href, onClick, children, className }: AnchorModel, ref) {
  const classes = useAnchorStyles();

  return (
    <a
      ref={ref}
      href={href}
      onClick={onClick}
      className={classnames(className, classes.root)}
    >
      {children}
    </a>
  );
}

export default forwardRef(Anchor);
